// @flow

import React,{Fragment} from 'react'
import { Link } from 'react-router-dom'
import Typed from 'react-typed';
import { connect } from 'react-redux'
import $ from "jquery";

import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import SupportListNew from '../partials/SupportListNew.jsx'
import BannerDemoNew from '../partials/BannerDemoNew.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import TryQuestionsWidget from '../partials/TryQuestionsWidget.jsx'
import TryQuestionsResult from '../partials/TryQuestionsResult.jsx'

import homeIMG from '../../images/hero_img_homepage.png'

import logo1 from '../../images/client_logo/kai.png'
import logo2 from '../../images/client_logo/unicharm.png'
import logo3 from '../../images/client_logo/astra.png'
import logo4 from '../../images/client_logo/telkom-akses.png'
import logo5 from '../../images/client_logo/mufg.png'
import logo6 from '../../images/client_logo/nus.png'
import logo7 from '../../images/client_logo/ntu.png'
import logo8 from '../../images/client_logo/ui.png'
import logo9 from '../../images/client_logo/petrosea.png'
import logo10 from '../../images/client_logo/qiscus.png'
import logo11 from '../../images/client_logo/awalkarir.png'
import logo12 from '../../images/client_logo/pulsifi.png'

import doubleCircle from '../../images/double-circle.png'
import doubleCircleSquare from '../../images/double-circle-square.png'

import teamtailorLogo from '../../images/logo/teamtailor.png'
import workableLogo from '../../images/logo/workable.png'
import pulsifiLogo from '../../images/logo/pulsifi.png'
import talentdatalabsLogo from '../../images/logo/talentdatalabs.png'
import podiumLogo from '../../images/logo/podium.png'
import greenhouseLogo from '../../images/logo/greenhouse.png'
import turfreyLogo from '../../images/logo/turfrey.png'

import caseIcon from '../../images/casestudies.png'
import exampleDemo from '../../images/example-demo.png'

import quoteIcon from '../../images/quote.svg'

import imgPlayStore from '../../images/rateAppGoogle.png'
import imgAppStore from '../../images/rateAppApple.png'
import imgPlayStoreMobile from '../../images/rateAppGoogleMobile.png'
import imgAppStoreMobile from '../../images/rateAppAppleMobile.png'

import imgFeature1 from '../../images/feature-1-video.png'
import imgFeature2 from '../../images/feature-2-structured.png'
import imgFeature3 from '../../images/feature-3-assessment.png'
import imgFeature4 from '../../images/feature-4-complete-suite.png'

import imgReview1 from '../../images/review-1.png'
import imgReview2 from '../../images/review-2.png'
import imgReview3 from '../../images/review-3.png'

import imgAssess from '../../images/imgAssess.png'
import imgVideoInterview from '../../images/img_video_interview.png'
import imgRecommends01 from '../../images/recommends_01.png'
import imgSkill from '../../images/img_skill_validation.png'
import imgSheeren from '../../images/img_sheeren.png'
import imgDevice from '../../images/img_device.png'
import imgDeviceMobile from '../../images/img_device_mobile.png'
import imgReport from '../../images/img_report.png'
import imgCornerRed from '../../images/corner-red.svg'
import imgCornerNavy from '../../images/corner-navy.svg'
import imgWithoutAstrnt from '../../images/without_astrnt.png'
import imgWithAstrnt from '../../images/with_astrnt.png'
import imgBuble01 from '../../images/img_buble_01.png'
import imgBuble02 from '../../images/img_buble_02.png'
import imgStep from '../../images/img_step.png'
import imgStepMobile from '../../images/img_step_mobile.png'

import logos from '../../images/logos.png'
import logo3success from '../../images/logo_3_success.png'
import logoTelkomAkses from '../../images/logo_telkomakses.png'

import personMBSB from '../../images/person_mbsb.png'
import logoMBSB from '../../images/logo_mbsb.png'

import personPintarnya from '../../images/person_pintarnya.png'
import logoPintarnya from '../../images/logo_pintarnya.png'

import personNUS from '../../images/person_nus.png'
import logoNUS from '../../images/logo_nus.png'

import bindAll from 'lodash/bindAll'
import { accesslog, translate } from '../../helpers/global'
import Cookies from 'js-cookie';
import { usersGetDetailAsync } from '../../actions/users.js'
import Carousel from '../partials/Carousel.jsx';

function shouldShowTryQuestions() {
  // Hidden by default -- opt in with ?view=try-question while the section is still being trialed.
  // return new URLSearchParams(window.location.search).get('view') === 'try-question'
  return true
}

type Props = {};

const quoteData =  [
  {
    icon:quoteIcon,
    text:'HOME_PAGE_CUSTOMERS_SAY_1',
    label:'Otniel Susanto',
  },
  {
    icon:quoteIcon,
    text:'HOME_PAGE_CUSTOMERS_SAY_2',
    label:'Heidi Smith',
  },
  {
    icon:quoteIcon,
    text:'HOME_PAGE_CUSTOMERS_SAY_3',
    label:'Franklin Mal',
  },
  {
    icon:quoteIcon,
    text:'HOME_PAGE_CUSTOMERS_SAY_4',
    label:'Solihatin Azizah',
  },
  {
    icon:quoteIcon,
    text:'HOME_PAGE_CUSTOMERS_SAY_5',
    label:'Fahmi Hasya',
  },
  {
    icon:quoteIcon,
    text:"HOME_PAGE_CUSTOMERS_SAY_6",
    label:'Eri Montinger',
  }
]


const featureDetail=[
  {
    top:'HOMEPAGE_RENDER_BUTTON_FEATURE_1',
    title:'HOMEPAGE_RENDER_TITLE_FEATURE_1',
    text:'HOMEPAGE_RENDER_TEXT_FEATURE_1',
    img:imgFeature1,
  },
  {
    top:'HOMEPAGE_RENDER_BUTTON_FEATURE_2',
    title:'HOMEPAGE_RENDER_TITLE_FEATURE_2',
    text:'HOMEPAGE_RENDER_TEXT_FEATURE_2',
    img:imgFeature3,
  },
  {
    top:'HOMEPAGE_RENDER_BUTTON_FEATURE_3',
    title:'HOMEPAGE_RENDER_TITLE_FEATURE_3',
    text:'HOMEPAGE_RENDER_TEXT_FEATURE_3',
    img:imgFeature2,
  },
  {
    top:'HOMEPAGE_RENDER_BUTTON_FEATURE_4',
    title:'HOMEPAGE_RENDER_TITLE_FEATURE_4',
    text:'HOMEPAGE_RENDER_TEXT_FEATURE_4',
    img:imgFeature4,
  },
]

class HomePageNew extends React.Component<Props> {

	constructor(props) {
		super(props)
    
    this.state={
      sliderStateIndex:0,
      quoteSliderStateIndex:0,
      buttonFeatureIndex:0,
      sliderIndex:1,
      sliderBigIndex:1,
      tryItAssessResult: null,
      tryItSignUpJobTitle: '',
      tryItSignUpSkill: '',
      tryItQuestionText: '',
      tryItQuestionCode: '',
      tryItAnswerText: '',
    }

		bindAll(this, [
			'handleRegisterLink',
      'moveSlide',
      'moveSlide1',
      'moveSlideBig',
      'renderFeature',
      'renderButtonFeature',
		])
	}
  handleTryItAnswered = (result, { skill, jobTitle, questionText, questionCode, answerText }) => {
    this.setState({
      tryItAssessResult: result,
      tryItSignUpJobTitle: jobTitle || skill,
      tryItSignUpSkill: skill,
      tryItQuestionText: questionText || '',
      tryItQuestionCode: questionCode || '',
      tryItAnswerText: answerText || ''
    })
  }

  moveSlide1(n)
  {
    const{sliderIndex} = this.state
    if (sliderIndex+n > 3) {
      this.setState({sliderIndex:1})
    }else if (sliderIndex+n < 1) {
      this.setState({sliderIndex:3})
    }else{
      this.setState({sliderIndex:sliderIndex+n})
    }
  }
  moveSlideBig(n)
  {
    const{sliderBigIndex} = this.state
    if (sliderBigIndex+n > 2) {
      this.setState({sliderBigIndex:1})
    }else if (sliderBigIndex+n < 1) {
      this.setState({sliderBigIndex:2})
    }else{
      this.setState({sliderBigIndex:sliderBigIndex+n})
    }
  }
  renderButtonFeature(){
    const{globalGetLanguages} = this.props
    const {buttonFeatureIndex} = this.state
    

    return (
      <Fragment>
                  <div className="div-button-feature">
                      <button onClick={()=>{
                        this.setState({
                          buttonFeatureIndex:0
                        })
                      }} className={`button-feature ${buttonFeatureIndex == 0 ? 'active' : ''} `}>{translate(globalGetLanguages,'HOMEPAGE_RENDER_BUTTON_FEATURE_1')}</button>
                      <button 
                       onClick={()=>{
                        this.setState({
                          buttonFeatureIndex:1
                        })
                      }} className={`button-feature ${buttonFeatureIndex == 1 ? 'active' : ''} `}>{translate(globalGetLanguages,'HOMEPAGE_RENDER_BUTTON_FEATURE_2')}</button>
                    </div>
                    <div className="div-button-feature">
                      <button
                       onClick={()=>{
                        this.setState({
                          buttonFeatureIndex:2
                        })
                      }}
                      className={`button-feature ${buttonFeatureIndex == 2 ? 'active' : ''} `}>{translate(globalGetLanguages,'HOMEPAGE_RENDER_BUTTON_FEATURE_3')}</button>
                      <button
                       onClick={()=>{
                        this.setState({
                          buttonFeatureIndex:3
                        })
                      }}
                      className={`button-feature ${buttonFeatureIndex == 3 ? 'active' : ''} `}>{translate(globalGetLanguages,'HOMEPAGE_RENDER_BUTTON_FEATURE_4')}</button>
                    </div>
      </Fragment>
    )
  }

  renderFeature(){
    const{globalGetLanguages} = this.props
    const {buttonFeatureIndex} = this.state

    return(
      <Fragment>
        <label>
        {translate(globalGetLanguages,featureDetail[buttonFeatureIndex].top)}</label>
        {translate(globalGetLanguages,featureDetail[buttonFeatureIndex].title)}
        <div className="mobile-hide text-center"><img src={featureDetail[buttonFeatureIndex].img} /></div>
        <span>{translate(globalGetLanguages,featureDetail[buttonFeatureIndex].text)}</span>
      </Fragment>
    )
  }

	componentDidMount() {
    // console.log(`ini os apa : ${getOSInfo().name}`)
    // console.log(`ini versi  : ${getOSInfo().version}`)
		window.scrollTo(0, 0);

    // $('.ban-text a.vid-msg').click(function(event){
    //     event.preventDefault();
        
    //     $('.pop').slideDown('fast');
    //     $('.overlay').fadeIn('fast');
    //     var video = document.getElementById('video-control')
    //     video.play();
        
    // });
    
    // $('.overlay, .pop a').click(function(event){
    //     event.preventDefault();
        
    //     $('.pop').slideUp('fast');
    //     $('.overlay').fadeOut('fast');
    //     var video = document.getElementById('video-control')
    //     video.pause();
    //     video.currentTime = 0;
    // });
    $('.with-container img:gt(0)').hide();
    setInterval(function () {
        $('.with-container :first-child').fadeOut().next('img').fadeIn().end().appendTo('.with-container');
    }, 3000);
	}

	handleRegisterLink(e: Object): void {
		e.preventDefault()

		const{
			history
		}=this.props
		
		history.push('/register')

		
	}

  moveSlide(e,params,quote=null){
    const{sliderStateIndex,quoteSliderStateIndex} = this.state
    if (quote) {
      if (params) {
        this.setState({quoteSliderStateIndex:quoteSliderStateIndex+1})
      }else{
        this.setState({quoteSliderStateIndex:quoteSliderStateIndex-1})
      }
    }else{
      if (params) {
        this.setState({sliderStateIndex:sliderStateIndex+1})
      }else{
        this.setState({sliderStateIndex:sliderStateIndex-1})
      }
    }
   
  }

  renderButtonDotSmall(quote=null){
    const{sliderStateIndex,quoteSliderStateIndex} = this.state
    let buttonSliderSmall = []
    if (quote) {
      quoteData.map((obj,index)=>{
        if (quoteSliderStateIndex == index) {
          buttonSliderSmall.push(
          <div ></div> 
  
            )
        }else{
          buttonSliderSmall.push(
            <div
            onClick={()=>{
              this.setState({quoteSliderStateIndex:index})
            }}
             className="disabled"></div>
            )
        }
       
      })
    }else{
      quoteData.map((obj,index)=>{
        if (sliderStateIndex == index) {
          buttonSliderSmall.push(
          <button ></button> 
  
            )
        }else{
          buttonSliderSmall.push(
            <button
            onClick={()=>{
              this.setState({sliderStateIndex:index})
            }}
             className="disabled"></button>
            )
        }
       
      })
    }
    

    return buttonSliderSmall
  }


  render() {
    const{globalGetLanguages,user,weeklyDemoData} = this.props
    const{buttonFeatureIndex,sliderIndex,sliderBigIndex} = this.state
    const renderHTML = (rawHTML: string) => React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });
    const typedcontent = (globalGetLanguages == 'id') ? ['Lulusan Baru', 'Profesional', 'Universitas', 'Karyawan &amp; Buruh', 'Lembaga Penilaian', 'Platform Talenta'] : ['Graduate Hiring', 'Professionals', 'Universities', 'Blue Collars', 'Assessments', 'Talent Platforms'] ;
    return (
			<div id="homepage">

        <div className="overlay" style={{display: 'none'}} />

        <HeaderNewClear isOnStatusLogo="is-on" />
        {/*        <div class="pad-top"></div>*/}
        <div className="banner home">
          <section>
            <div className="ban-text">
              <div className="big-text" style={globalGetLanguages == 'id' ? {fontSize: '40px',lineHeight: '120%'} : {}}>Recommendations</div>
              <div className="big-text" style={globalGetLanguages == 'id' ? {fontSize: '40px',lineHeight: '120%'} : {}}>and Solutions</div>
              <div className="big-text" style={globalGetLanguages == 'id' ? {fontSize: '40px',lineHeight: '120%'} : {}}>for All Talent Decisions</div>
              <div className="content-desc">Partnering Employers, Universities & Talent Ecosystem for Talent Recommendations.</div>
              <div className={`ban-link`} style={globalGetLanguages == 'id' ? {margin: '0'} : {margin: '8px 0 0'}}>
                <Link to={{pathname: `/talent-acquisition/astrnt-recommends`, query: { plan: 'free' }}} className="try"
                  onClick={() => accesslog('homepage', 'button_register', {title: 'Experience Talent Recommendations'}) }
                >{translate(globalGetLanguages,'HOMEPAGE_SIGNUP_TODAY')}</Link>
                <a onClick={() => {
                  accesslog('homepage', 'button_talk_to_an_expert');
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                }} className="request-demo-logged">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a>
              </div>
              <div className={`ban-link hide`}>
                <a onClick={() => {
                  accesslog('homepage', 'button_talk_to_an_expert');
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                }} className="request-demo-logged">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a>
              </div>
              {/* <span className={`span-cc desktop-hide`}>{translate(globalGetLanguages,'HOMEPAGE_LABEL_NO_CREDIT_CARD')}</span> */}
              <a href="#" className="vid-msg">
                <img src={homeIMG} />
              </a>
            </div>
          </section>
          {/*<div className="ban-img" />*/}
        </div>
        <div className="section-white relative">
          <section className="partner">
            <div className="part-wrap">
              <ul>
                <li><a><img src={logo1} /></a></li>
                <li><a><img src={logo2} /></a></li>
                <li><a><img src={logo3} /></a></li>
                <li><a><img src={logo4} /></a></li>
                <li><a><img src={logo5} /></a></li>
                <li><a><img src={logo6} /></a></li>
                <li><a><img src={logo7} /></a></li>
                <li><a><img src={logo8} /></a></li>
                <li><a><img src={logo9} /></a></li>
                <li><a><img src={logo10} /></a></li>
                <li><a><img src={logo11} /></a></li>
                <li><a><img src={logo12} /></a></li>
              </ul>
            </div>
          </section>
        </div>
        <div className="section-white half-blue" style={{position: 'relative', overflow: 'hidden'}}>
          <span className="blue-curve-middle-left"></span>
          <span className="blue-curve-middle-right"></span>
          <section className='flex-container'>
            <div className="review-feature">

              <div className="review-list">
                <div>
                  <h2>Talent Acquisition</h2>
                  <p>
                    "Integrating and collaborating with ASTRNT for a strong digital recruitment strategy was the smartest decision ever. We considered both candidate experience and process efficiency to make sure things are scalable in the long run."
                  </p>
                </div>
                <div>
                  <label><b> — Nur Syahada Taufek</b>, Talent Acquisition & Employer Branding Manager, <b>MBSB Bank Berhad</b></label>
                  <div className="text-center"><a onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('homepage', 'button_talk_to_an_expert', {title: 'Talent Acquisition'});
                  }} className="btn-talk-expert">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a></div>
                </div>
              </div>
              <div className="review-list">
                <div>
                  <h2>University</h2>
                  <p>
                    "ASTRNT platform gave us a holistic view of each candidate to be surgically precise at selecting the very best talents for our NUS cohorts."
                  </p>
                </div>
                <div>
                  <label><b> — Winston Wee</b>, Head of Admissions for MSc Programs, <b>National University of Singapore (NUS) Business School</b></label>
                  <div className="text-center"><a onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('homepage', 'button_talk_to_an_expert', {title: 'University'});
                  }} className="btn-talk-expert">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a></div>
                </div>
              </div>
              <div className="review-list">
                <div>
                  <h2>Talent Management</h2>
                  <p>
                    "The assessment results conducted by the NextGen Assessment Center method are identical to those of traditional assessment centers, but achieved much faster and budget-friendly."
                  </p>
                </div>
                <div>
                  <label><b> — Effy Abadi</b>, SGM HC Management, <b>Telkom Akses</b></label>
                  <div className="text-center"><a onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('homepage', 'button_talk_to_an_expert', {title: 'Talent Management'});
                  }} className="btn-talk-expert">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a></div>
                </div>
              </div>
              
            </div>
          </section>
        </div>
        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h1 className='m-t-0 m-b-24'>
                    ASTRNT Recommends
                  </h1>
                  <p className='m-b-24'>Get your best-fit talent recommendations, backed by talent background, psychometric assessments, video interviews, and competency data.</p>
                  <ul className="m-b-32">
                    <li><i className="fas fa-check" />Role-based talent recommendations</li>
                    <li><i className="fas fa-check" />Clear justification for every recommendation</li>
                    <li><i className="fas fa-check" />Highlight top-fit talents faster</li>
                    <li><i className="fas fa-check" />Clearer hiring decisions with less manual screening</li>
                  </ul>
                  <Link to={{pathname: `/talent-acquisition/astrnt-platform/astrnt-recommends`}} className="btn-primary"
                    onClick={() => accesslog('homepage', 'button_learn_more', {title: 'ASTRNT Recommends'}) }
                  >{translate(globalGetLanguages,'HEADER_TRY_NOW')}</Link>
                </div>
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgRecommends01} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgVideoInterview} />
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h1 className='m-t-0 m-b-24'>
                    AI Video Interview
                  </h1>
                  <p className='m-b-24'>Deliver consistent, on-demand interviews supported by AI<br />to assess thinking, communication, and fit.</p>
                  <ul className="m-b-32">
                    <li><i className="fas fa-check" />Structured question flows</li>
                    <li><i className="fas fa-check" />AI scoring</li>
                    <li><i className="fas fa-check" />Multiple response formats (video, text, audio, screen <br />recording)</li>
                    <li><i className="fas fa-check" />Customisable timing & branding</li>
                  </ul>
                  <Link to={{pathname: `/talent-acquisition/astrnt-platform/ai-structured-video-interview`}} className="btn-primary"
                    onClick={() => accesslog('homepage', 'button_learn_more', {title: 'AI Video Interview'}) }
                  >{translate(globalGetLanguages,'HEADER_TRY_NOW')}</Link>
                </div>
              </div>
            </div>
          </section>
        </div>
        {shouldShowTryQuestions() && (
          <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
            <section className='flex-container'>
              <div className='flex-item-left' style={{zIndex: '1'}}>
                <div className='vertical-item--center'>
                  <div className='sec-desc'>
                    <h1 className='m-t-0 m-b-24'>
                      Try It Yourself
                    </h1>
                    <p className='m-b-24'>Answer one question on video and see how ASTRNT scores you. No sign-up.</p>
                    <TryQuestionsWidget source="homepage" compact onAnswered={this.handleTryItAnswered} />
                    <TryQuestionsResult
                      assessResult={this.state.tryItAssessResult}
                      jobTitle={this.state.tryItSignUpJobTitle}
                      skill={this.state.tryItSignUpSkill}
                      questionText={this.state.tryItQuestionText}
                      questionCode={this.state.tryItQuestionCode}
                      answerText={this.state.tryItAnswerText}
                      source="homepage"
                      compact
                      wrapInSection={false}
                    />
                  </div>
                </div>
              </div>
              <div className='flex-item-right' style={{zIndex: '1'}}>
                <div className='vertical-item--center'>
                  <img className='img-80' src={imgRecommends01} />
                </div>
              </div>
            </section>
          </div>
        )}
        <div className="section-white" style={{position: 'relative'}}>
          <span class="red-curve-bottom-left"></span>
          <section className='flex-container relative'>
            <img className="double-circle" src={doubleCircle} />
            <div className='flex-item-left' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h1 className='m-t-0 m-b-24'>
                    Skill Validation
                  </h1>
                  <p className='m-b-24'>Assess real skills—not just CVs. ASTRNT validates <br />technical, behavioral, and situational capability.</p>
                  <ul className="m-b-32">
                    <li><i className="fas fa-check" />Role-based assessments</li>
                    <li><i className="fas fa-check" />Scenario-based tests</li>
                    <li><i className="fas fa-check" />AI-generated scoring and reports</li>
                    <li><i className="fas fa-check" />Combine with video interviews for faster decisions <br />based on deeper insight</li>
                  </ul>
                  <Link to={{pathname: `/talent-acquisition/skill-validation`}} className="btn-primary"
                    onClick={() => accesslog('homepage', 'button_learn_more', {title: 'Skill Validation'}) }
                  >{translate(globalGetLanguages,'HEADER_TRY_NOW')}</Link>
                </div>
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSkill} />
              </div>
            </div>
            <img className="double-circle-square" src={doubleCircleSquare} />
          </section>
        </div>
        <div className="section-red triangle-left section-slider" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container container-slider-absolute'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <Carousel/>
              </div>
            </div>
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc white slider-red'>
                  <h1 className='m-t-0 m-b-24'>
                    Customer Stories
                  </h1>
                  <p className='text-desc-stories'>Explore authentic abilities that go far beyond traditional resumes. ASTRNT is dedicated to showcasing real-world experiences that truly matter, highlighting not just technical skills but also behavioral and situational competencies.</p>
                  <Link to={{pathname: `/learn`}} onClick={() => {
                    localStorage.setItem('selectedLearnCategory', 'customer-story');
                    localStorage.setItem('fromHeaderNavigation', 'true');
                    accesslog('homepage', 'button_view_all_stories');
                  }} className="btn-stories">View All Stories</Link>
                </div>
              </div>
            </div>
          </section>
          <span class="white-curve-bottom-right"></span>
        </div>
        <div className={`section-white single-triangle triangle-right ${weeklyDemoData && weeklyDemoData.webinar_link ? '' : 'hide'}`} style={{position: 'relative'}}>
          <section className='p-t-100 p-b-100'>
            <div className='weekly-demo'>
              <h1>Join Our Weekly Demo Show</h1>
              <h4>Explore how ASTRNT works in action through our weekly live platform walkthrough.</h4>
              <div className="card-weekly-demo">
                <img src={weeklyDemoData && weeklyDemoData.image_url ? weeklyDemoData.image_url : exampleDemo} />
                <div className="weekly-text">
                  <h2 className='m-t-0 m-b-12'>
                    {weeklyDemoData && weeklyDemoData.title ? weeklyDemoData.title : "A Practical Method to Identify & Select the Right Talent Quickly"}
                  </h2>
                  <p className='m-b-24'>{weeklyDemoData && weeklyDemoData.desc ? weeklyDemoData.desc : "Quickly identify and select the right talent by assessing real skills beyond just resumes. ASTRNT evaluates technical, behavioral, and situational abilities."}</p>
                  <a href={weeklyDemoData && weeklyDemoData.webinar_link ? weeklyDemoData.webinar_link : '#'} target="_blank" rel="noopener noreferrer" className="btn-primary"
                    onClick={() => accesslog('homepage', 'button_register_for_demo', {title: weeklyDemoData && weeklyDemoData.title ? weeklyDemoData.title : "Default Demo"}) }
                  >Register for Demo</a>
                </div>
              </div>
            </div>
          </section>
        </div>
        {/*<BlogListNew />*/}
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return{ 
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData,
  }
  
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePageNew)
